import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { useNotification } from '../../contexts/NotificationContext';
import { TextField, Typography } from '@mui/material';
import {
    Person,
    Key,
    Numbers,
    Email,
    ArrowBack
} from '@mui/icons-material';
import OTPInput from './OTPComp';
import { get_otp, verify_otp, login_with_password, signup } from '../../services/loginServices';
import { useAuth } from '../../contexts/AuthContext';
import { useRestaurant } from '../../contexts/RestaurantContext';



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    borderRadius:'25px',
    boxShadow: 24,
    p: 4,
};




//   ---------------------------------------- MODAL LEVELS ----------------------------------------------------------
const LevelOne = ({ loginLevel, setLoginLevel }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' sx={{textAlign:'center', mb:2}}>Choose Your Preferred Login Method</Typography>
        <Button variant='contained' sx={{ marginBottom: 2 }} onClick={() => setLoginLevel(2)}>
           <Key style={{marginRight:'7px'}} /> Login with Password
        </Button>
        <Button variant='contained' sx={{ marginBottom: 2 }} onClick={() => setLoginLevel(3)}>
           <Numbers style={{marginRight:'7px'}} />  Login with OTP
        </Button>
        <Button sx={{ marginBottom: 2 }} onClick={() => setLoginLevel(5)}>
            Don't Have a Account ? Sign Up
        </Button>

    </Box>
);

const LevelTwo = ({ passwordType, handlePasswordType, handleLoginWithPassword }) => {
    return (
        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ mb: 2, textAlign: 'center', fontWeight: '600 !important' }}>
                Login With Password
            </Typography>
            <TextField fullWidth
                name="phone"
                label="Email or Phone Number"
                value={passwordType.phone}
                onChange={(e) => handlePasswordType(e)}
                required
                size="medium"
                InputProps={{
                    startAdornment: <Person sx={{ color: 'text.secondary', mr: 1 }} />
                }}
                sx={{
                    mb: 4,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2
                    }

                }}
            >
            </TextField>

            <TextField fullWidth
                name="password"
                label="Password"
                type='password'
                value={passwordType.password}
                onChange={(e) => handlePasswordType(e)}
                required
                size="medium"
                InputProps={{
                    startAdornment: <Key sx={{ color: 'text.secondary', mr: 1 }} />
                }}
                sx={{
                    mb: 4,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2
                    }

                }}
            >
            </TextField>

            <Button variant='contained'
                onClick={handleLoginWithPassword}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                    }
                }} >
                Login
            </Button>
        </Box >
    )
}

const LevelThree = ({ otpType, handlePhoneNumberChange, submitGetOTP, loginLevel, setLoginLevel }) => {
    return (
        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ mb: 2, textAlign: 'center', fontWeight: '600 !important' }}>
                Login With One Time Password - (OTP)
            </Typography>
            <TextField fullWidth
                name="phone"
                label="Email or Phone Number"
                value={otpType.phone}
                onChange={(e) => handlePhoneNumberChange(e)}
                required
                size="medium"
                InputProps={{
                    startAdornment: <Numbers sx={{ color: 'text.secondary', mr: 1 }} />
                }}
                sx={{
                    mb: 4,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2
                    }
                }}
            >
            </TextField>

            <Button variant='contained'
                onClick={submitGetOTP}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                    }
                }} >
                Get OTP
            </Button>
        </Box >
    )
}

const LevelFour = ({submitOTP,otp,setOtp }) => {
    // const [otp, setOtp] = useState(new Array(6).fill(""));
    // const { loginUser, setLoginUser } = useRestaurant()

    

    return (
        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ mb: 2, textAlign: 'center', fontWeight: '600 !important' }}>
                Verify OTP
            </Typography>
            <OTPInput length={6} otp={otp} setOtp={setOtp} />
            <Button variant='contained'
                onClick={submitOTP}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                    }
                }} >
                Verify
            </Button>
        </Box >
    )
}



const LevelFive = ({ signUpData, setSignUpData, handleSignUpChange, submitSignupData }) => {
    return (
        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ mb: 2, textAlign: 'center', fontWeight: '600 !important' }}>
                Sign Up
            </Typography>
            <TextField fullWidth
                name="username"
                label="Name"
                value={signUpData.name}
                onChange={(e) => handleSignUpChange(e)}
                required
                size="medium"
                InputProps={{
                    startAdornment: <Person sx={{ color: 'text.secondary', mr: 1 }} />
                }}
                sx={{
                    mb: 4,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2
                    }

                }}
            >
            </TextField>

            <TextField fullWidth
                name="password"
                label="Password "
                type='password'
                value={signUpData.password}
                onChange={(e) => handleSignUpChange(e)}
                required
                size="medium"
                InputProps={{
                    startAdornment: <Key sx={{ color: 'text.secondary', mr: 1 }} />
                }}
                sx={{
                    mb: 4,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2
                    }

                }}
            >
            </TextField>
            <TextField fullWidth
                name="phone"
                label="Phone Number "
                value={signUpData.phone}
                onChange={(e) => handleSignUpChange(e)}
                required
                size="medium"
                InputProps={{
                    startAdornment: <Numbers sx={{ color: 'text.secondary', mr: 1 }} />
                }}
                sx={{
                    mb: 4,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2
                    }

                }}
            >
            </TextField>
            <TextField fullWidth
                name="email"
                label="Email (Optional)"
                value={signUpData.email}
                onChange={(e) => handleSignUpChange(e)}
                
                size="medium"
                InputProps={{
                    startAdornment: <Email sx={{ color: 'text.secondary', mr: 1 }} />
                }}
                sx={{
                    mb: 4,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2
                    }

                }}
            >
            </TextField>

            <Button variant='contained'
                onClick={submitSignupData}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                    }
                }} >
                Login
            </Button>
        </Box >
    )
}





//  ========================================= MAIN MODAL COMPONENET ========================================

export default function LoginModal({ loginModalOpen, setLoginModalOpen }) {
    const { showError, showSuccess } = useNotification();
    const [loginLevel, setLoginLevel] = useState(1);
    const { loginUser, setLoginUser } = useRestaurant()
    const [passwordType, setPasswordType] = useState({
        'phone': "",
        'password': ""
    })

    const [otpType, setOtpType] = useState({
        'phone': ""
    })

    const [signUpData, setSignUpData] = useState({
        "username": "",
        "password": "",
        "email": "",
        "phone": ""
    })
     const [otp, setOtp] = useState(new Array(6).fill(""));


    //  -------------- Use Effects ------------------------
    useEffect(() => {

    }, [loginLevel])

    //  -----------------  Methods -------------------- 

    const handlePasswordType = (e) => {
        const updateData = {
            ...passwordType,
            [e.target.name]: e.target.value
        }

        setPasswordType(updateData)
    }

    const handleLoginWithPassword = async (e) => {
        try {
            const response = await login_with_password(passwordType);
            localStorage.setItem('access_token', response.access_token);
            localStorage.setItem('refresh_token', response.refresh_token);
            sessionStorage.setItem('user', JSON.stringify(response.user));
            setLoginUser(response.user);
            showSuccess("User Logged in Successfully");
            setLoginModalOpen(false)
            setLoginLevel(1);
        }
        catch (error) {
            console.error("Error Occured ", error)
            showError("Login Failed Please Try Again Later");
        }

    }

    const handlePhoneNumberChange = (e) => {
        const updateData = {
            ["phone"]: e.target.value
        }
        setOtpType(updateData)
    }


    //  ================  OTP Handlers ======================
    const submitGetOTP = async () => {
        let response;
        try{
        response = await get_otp();
        showSuccess(response.message)
        setLoginLevel(4);
        }
        catch(error){
            console.error("Error on OTP Getting => " , error);
            showError(response?.detail || "Something Went Wrong")
        }
        

    }

    const submitOTP = async () => {
        let actualOTP = otp.join("")
        let data = {
            "phone": '+919159862847',
            "otp": actualOTP.toString()
        }
        try {

            const response = await verify_otp(data);

            localStorage.setItem('access_token', response.access_token);
            localStorage.setItem('refresh_token', response.refresh_token);
            sessionStorage.setItem('user', JSON.stringify(response.user));
            setLoginUser(response.user);
            showSuccess("User Logged in Successfully");
            setLoginLevel(1);
            setLoginModalOpen(false)


        }
        catch (error) {
            console.error("error Occured = >", error);
            showError("OTP Verification Failed");
        }

    }

    //  ==================== Sign UP Handlers ===========================
    const handleSignUpChange = (e) => {
        const updateData = {
            ...signUpData,
            [e.target.name]: e.target.value
        }

        setSignUpData(updateData)
    }

    const submitSignupData = async () => {
        try {
            const response = await signup(signUpData);
            showSuccess("User Signup Process Successfully Completed")
            setLoginLevel(1);
            setLoginModalOpen(false)
            setSignUpData({
                "username": "",
                "password": "",
                "email": "",
                "phone": ""
            })
        }
        catch (error) {
            console.error("Error Occured on Signup => ", error);
            showError("Sign Up failed Please Try Again Later");
        }
    }


    const renderModalContent = () => {
        switch (loginLevel) {
            //  ------------  Selection Stage ------------------
            case 1:
                return <LevelOne loginLevel={loginLevel} setLoginLevel={setLoginLevel} />;

            //  ------------  Login With Password ------------------
            case 2:
                return <LevelTwo passwordType={passwordType} handlePasswordType={handlePasswordType} loginLevel={loginLevel} setLoginLevel={setLoginLevel} handleLoginWithPassword={handleLoginWithPassword} />;

            //  ------------  Login With OTP ------------------
            case 3:
                return <LevelThree otpType={otpType} handlePhoneNumberChange={handlePhoneNumberChange} submitGetOTP={submitGetOTP} loginLevel={loginLevel} setLoginLevel={setLoginLevel} />

            //  ------------  Verify OTP ------------------
            case 4:
                return <LevelFour submitOTP={submitOTP} otp={otp} setOtp={setOtp} />

            // ----------- Sign UP Stage --------------
            case 5:
                return <LevelFive signUpData={signUpData} setSignUpData={setSignUpData} handleSignUpChange={handleSignUpChange} submitSignupData={submitSignupData} showError={showError} showSuccess={showSuccess} setLoginModalOpen={setLoginModalOpen} loginLevel={loginLevel} setLoginLevel={setLoginLevel} />

            default:
                return null;
        }
    };

    return (
        <Modal
            open={loginModalOpen}
            onClose={() => {
                setLoginLevel(1);
                setLoginModalOpen(false);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Button onClick={()=>setLoginLevel(1)} sx={{position:'relative', right:'20px'}} >
                    <ArrowBack style={{fontSize:'8px'}} />
                </Button>
                
                {renderModalContent()}
            </Box>
        </Modal>
    );
}
